import React from 'react';
import UserCards from './UserCard';


const UserList = () => {
  return (
    <UserCards />
  );
};

export default UserList;
